document.addEventListener('DOMContentLoaded', () => {
  // Back buttons: close the nearest open <details> (works for any nesting depth)
  document.querySelectorAll('.nav-sidebar__back-button').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      // Close the closest open details (the current level)
      const currentOpenDetails = button.closest('details[open]');
      if (currentOpenDetails) {
        currentOpenDetails.removeAttribute('open');

        // Optional: move focus back to the summary of the closed level
        const summary = currentOpenDetails.querySelector(':scope > summary');
        if (summary) summary.focus();
      }
    });
  });

  // Optional enhancement: when a summary opens, focus first link inside its dropdown
  // Works for all levels (nested details)
  document.querySelectorAll('.nav-sidebar details > summary').forEach((summary) => {
    summary.addEventListener('click', () => {
      const details = summary.closest('details');
      if (!details) return;

      // After the <details> opens, focus the first link in its dropdown
      setTimeout(() => {
        if (!details.hasAttribute('open')) return;

        const firstLink = details.querySelector(
          '.nav-sidebar__dropdown a, .nav-sidebar__dropdown button'
        );
        if (firstLink) firstLink.focus();
      }, 50);
    });
  });
});
